<h1 mat-dialog-title>{{ notification.title }}</h1>
<div mat-dialog-content>
  <p>{{ notification.message }}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="handleOkClicked()">
    OK
  </button>
</div>
